import { formatDate } from "../../../util/helperFunctions";


import * as R from "rambda";

export const findLastDate = (inputdata, element, sensorID) => {
    if (
        R.path(["result", sensorID, element, "dates"], inputdata) !== undefined
    ) {
        const dates_List = R.path(
            ["result", sensorID, element, "dates"],
            inputdata
        );
        const missing_List = R.path(
            ["result", sensorID, element, "missing"],
            inputdata
        );

        // Get the last date where the data is not missing
        // missing_List is an array of 0s and 100s, where 0 means data is available and 100 means data is missing

        // Find index of last non-missing data
        const lastNonMissingIndex = missing_List.lastIndexOf(0);

        // Get the date of the last non-missing data
        const lastDate = formatDate(new Date(dates_List[lastNonMissingIndex]));
        return lastDate;
    }
};

export const findAvgPredDateRange = (inputdata, element, sensorID) => {
    if (
        R.path(["result", sensorID, element, "dates"], inputdata) !== undefined
    ) {
        const dates_List = R.path(
            ["result", sensorID, element, "dates"],
            inputdata
        );
        const missing_List = R.path(
            ["result", sensorID, element, "missing"],
            inputdata
        );

        // Get the last date where the data is not missing
        // missing_List is an array of 0s and 100s, where 0 means data is available and 100 means data is missing

        // Find index of last non-missing data
        const lastNonMissingIndex = missing_List.lastIndexOf(0);

        // Get the date of the last non-missing data
        const lastDate = new Date(dates_List[lastNonMissingIndex]);
        const initialDate = new Date(new Date(lastDate).setDate(lastDate.getDate() - 100));

        return `${formatDate(initialDate)} - ${formatDate(lastDate)}`;
    }
};

// this function is designed to  return latest non zero corrosion rate
export const findFirstNonZeroCorrosionRate = (corrosionData) => {
    var index = 0;
    if (corrosionData[index].toFixed(3) === "0.000") {
        return corrosionData[index].toFixed(3);
    }
    return corrosionData[index].toFixed(3);
};

export const findFirstAndLastDate = (inputdata, element, sensorID) => {
    if (
        R.path(["result", sensorID, element, "data"], inputdata) !== undefined
    ) {
        const dates_List = R.path(
            ["result", sensorID, element, "dates"],
            inputdata
        );
        const missing_List = R.path(
            ["result", sensorID, element, "missing"],
            inputdata
        );

        // Get the last date where the data is not missing
        // missing_List is an array of 0s and 100s, where 0 means data is available and 100 means data is missing

        // Find index of last non-missing data
        const lastNonMissingIndex = missing_List.lastIndexOf(0);

        // Get the date of the last non-missing data
        const lastDate = new Date(dates_List[lastNonMissingIndex]);


        // Find index of first non-missing data
        const firstNonMissingIndex = missing_List.indexOf(0);

        // Get the date of the first non-missing data
        const initialDate = new Date(dates_List[firstNonMissingIndex]);

        if (JSON.stringify(initialDate) === "null") {
            return null;
        } else return `${formatDate(initialDate)} - ${formatDate(lastDate)}`;
    }
};

export const findLastValue = (inputdata, element, sensorID) => {
    if (
        R.path(["result", sensorID, element, "data"], inputdata) !== undefined
    ) {
        const data_List = R.path(
            ["result", sensorID, element, "data"],
            inputdata
        );
        const lastValue = data_List
            .filter((item, index) => data_List[index] > 0)
            .at(-1);
        return lastValue;
    }
};

export const findMinMaxMissingValuesInTrainPeriod = (inputdata, element, sensorID, train_period) => {
    if (
        R.path(["result", sensorID, element, "data"], inputdata) !== undefined
    ) {
        const data_List = R.path(
            ["result", sensorID, element, "data"],
            inputdata
        );
        const dates_List = R.path(
            ["result", sensorID, element, "dates"],
            inputdata
        ).map((v) => new Date(v));
        const start = new Date(R.path(["start"], train_period));
        const end = new Date(R.path(["end"], train_period));
        const filtered_data = data_List.filter(
            (item, index) => dates_List[index] >= start && dates_List[index] <= end
        );
        const minValue = Math.round(100 - Math.max.apply(Math, filtered_data));
        const maxValue = Math.round(100 - Math.min.apply(Math, filtered_data));
        if (minValue === maxValue) {
            return `${minValue}%`;
        } else {
            return `${minValue}-${maxValue}%`;
        }
    }
};